import segment from 'src/js/modules/analytics/segment';

const {
  constants: { events, triggerIds },
  trackers: { trackEvent },
} = segment;

const trackEditingViewSelectClicked = ({ breakpointType }) => {
  trackEvent(events.EDITING_VIEW_SELECT_CLICKED, {
    breakpointType,
    triggerId: triggerIds.ELEMENT_SETTINGS,
  });
};

export default trackEditingViewSelectClicked;
